export const BlockedIcon = () => <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_18393_37107)">
        <path d="M12.5 22.9163C18.253 22.9163 22.9167 18.2526 22.9167 12.4997C22.9167 6.74671 18.253 2.08301 12.5 2.08301C6.74704 2.08301 2.08334 6.74671 2.08334 12.4997C2.08334 18.2526 6.74704 22.9163 12.5 22.9163Z" stroke="#E74C3C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.13541 5.13574L19.8646 19.8649" stroke="#E74C3C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
        <clipPath id="clip0_18393_37107">
            <rect width="25" height="25" fill="white" />
        </clipPath>
    </defs>
</svg>
